import { put, call, takeLatest, delay } from 'redux-saga/effects';
import axios from 'axios';
import config from '../config';
import Cookies from 'js-cookie';

//Action
import { loadingSet } from '../action/uiAction';


function* memoListGet(action) {
  yield put(loadingSet(true));
  const {res, err} = yield call(function(payload) {
    var params = new URLSearchParams();
    params.append('ULIC', Cookies.get('ULIC'));
    params.append('ULPC', Cookies.get('ULPC'));
    if (payload.text) {
      payload.text.split(" ").map( (value, index) => params.append('text[]', value) );
    }
    params.append('page', payload.page);
    return axios.post(config.apiUri + "member/memoListApi.php", params, {
      timeout: 5000
    })
    .then((res) => {
      return {res};
    })
    .catch((err) => {
      return {err};
    })
  }, action.payload);
  yield delay(100);
  if (res) {
    if (res.data.bool) {
      yield put({
        type: "MEMO_LIST_SET",
        payload: {
          list: res.data.list,
          text: action.payload.text,
          page: action.payload.page,
          isListNext: res.data.isListNext,
        },
      });
    }
  }
  if (err) {
    yield put({ type: 'SNACK_SET', payload: {visible: true, severity: 'error', duration: 5000, comment: config.apiErrComment} });
  }
  yield put(loadingSet(false));
}

function* memoListEdit(action) {
  yield put(loadingSet(true));
  const {res, err} = yield call(function(payload) {
    var params = new URLSearchParams();
    params.append('ULIC', Cookies.get('ULIC'));
    params.append('ULPC', Cookies.get('ULPC'));
    params.append('pic', payload.pic);
    params.append('text', payload.text);
    return axios.post(config.apiUri + "member/memoEditApi.php", params, {
      timeout: 5000
    })
    .then((res) => {
      return {res};
    })
    .catch((err) => {
      return {err};
    })
  }, action.payload);

  if (res) {
    if (res.data.bool) {

      if (res.data.type === 'add') {
        yield put({
          type: "MEMO_LIST_DATETIME_INIT",
        })
      }
      else {
        yield put({
          type: "MEMO_ITEM_SET",
          payload: {
            type: res.data.type,
            pic: action.payload.pic,
            text: action.payload.text,
          },
        });
      }
      yield put({
        type: "SEARCH_ITEM_MEMO_SET",
        payload: {
          pic: action.payload.pic,
          text: action.payload.text,
        },
      });
      yield put({ type: 'SNACK_SET', payload: {visible: true, severity: 'success', duration: 5000, comment: res.data.comment} });
    }
  }
  if (err) {
    yield put({ type: 'SNACK_SET', payload: {visible: true, severity: 'error', duration: 5000, comment: config.apiErrComment} });
  }
  yield put(loadingSet(false));
}

const saga = [
  takeLatest('MEMO_LIST_GET', memoListGet),
  takeLatest('MEMO_LIST_EDIT', memoListEdit),
];

export default saga;
